export function AnyOf(...permissions) {
    const p = Array.from(permissions);
    p.__AnyOf__ = true;
    return p;
}
export function AllOf(...permissions) {
    return Array.from(permissions);
}
export function isAnyOf(permissions) {
    return permissions.__AnyOf__ === true;
}
//# sourceMappingURL=helpers.js.map